import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';
import '../styles/pages/CheckoutSuccess.scss';

const CheckoutSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderNumber } = location.state || {};

  return (
    <div className="checkout-success-page">
      <div className="success-container">
        <FiCheckCircle className="success-icon" />
        <h1>Commande Confirmée!</h1>
        <p>Merci pour votre commande. Elle a été traitée avec succès.</p>
        
        {orderNumber && (
          <div className="order-details">
            <p>Votre numéro de commande: <strong>{orderNumber}</strong></p>
            <p>Votre commande est en cours de traitement et sera préparée dans les plus brefs délais.</p>
          </div>
        )}

        <div className="success-actions">
          <button onClick={() => navigate('/Products')}>
            Continuer vos achats
          </button>
          <button onClick={() => navigate('/')} className="home-btn">
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;